module.exports = __webpack_public_path__ + "static/media/sellability.a682c428.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/sellability.png
// module id = 381
// module chunks = 17